import React from 'react';
import { Logo } from './Logo';
import { site } from '../data/site';
export function Footer() {
  return <footer className="w-full bg-[#071B49]" data-id="element-46" data-mp="3gfiu2hdxs9dl">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-10 px-6 py-14 md:flex-row md:items-end md:justify-between" data-id="element-47" data-mp="3ghc323c0v5or">
        <div data-id="element-48" data-mp="36pfv80k4w17c">
          <Logo inverted data-id="element-49" data-mp="36oy0x9h17x22" />
          <p className="mt-5 text-sm text-sky-200/70" data-id="element-50" data-mp="36q92r3qx2uqj">{site.tagline}</p>
        </div>

        <div className="text-sm text-sky-100/70" data-id="element-51" data-mp="3ug3etj3ewf9q">
          <p className="text-white" data-id="element-52" data-mp="3ud7h9vvh7slt">{site.owner}</p>
          <p className="mt-1 text-sky-300" data-id="element-53" data-mp="37o7iyd163ey">{site.ownerTitle}</p>
          <p className="mt-4" data-id="element-54" data-mp="3lem1u9lawtp9">
            <a href={site.phoneHref} className="hover:text-white" data-id="element-55" data-mp="3ldan5eqbi1jd">
              {site.phone}
            </a>
          </p>
          <p data-id="element-56" data-mp="3qbvnrf9hen8c">
            <a href={site.emailHref} className="hover:text-white" data-id="element-57" data-mp="3qfjiuiukrhp6">
              {site.email}
            </a>
          </p>
          <p className="mt-1" data-id="element-58" data-mp="2eya0jzn6mvpg">{site.location}</p>
        </div>
      </div>

      <div className="border-t border-white/10 bg-[#1D4ED8]" data-id="element-59" data-mp="2ew6z8jgkxg5f">
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-2 px-6 py-5 text-[11px] uppercase tracking-[0.2em] text-white/80 sm:flex-row sm:items-center sm:justify-between" data-id="element-60" data-mp="3lalgfg6ys7uh">
          <p data-id="element-61" data-mp="3v89fgibls1ig">{site.badges.join(' · ')}</p>
          <p data-id="element-62" data-mp="3v918pmhq9n5k">
            © {new Date().getFullYear()} {site.name} {site.category}
          </p>
        </div>
      </div>
    </footer>;
}